var _path, _path2, _path3, _path4, _path5, _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 726,
    height: 64,
    viewBox: "0 0 726 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_63_7015",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 726,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H714C720.627 0 726 5.37258 726 12V64H0V12Z",
    fill: "url(#paint0_linear_63_7015)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_63_7015)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M726 0L0 0L0 64L726 64V0Z",
    fill: "#B9E9E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M726 0L0 0L0 64L726 64V0Z",
    fill: "#309F9D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_63_7015",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 726,
    height: 64
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H714C720.627 0 726 5.37258 726 12V64H0V12Z",
    fill: "url(#paint1_linear_63_7015)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_63_7015)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M726 0L0 0L0 64L726 64V0Z",
    fill: "#13325A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_63_7015",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: -1681,
    width: 2212,
    height: 2212
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2230.45,
    y: -1418.39,
    width: 2756.09,
    height: 371.382,
    transform: "rotate(135 2230.45 -1418.39)",
    fill: "url(#paint2_linear_63_7015)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_63_7015)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2004.67 -1612.62L95.2712 296.776L302.571 504.076L2211.97 -1405.32L2004.67 -1612.62Z",
    fill: "#B0ECE6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2109.87 -1507.42L2004.67 -1612.62L95.2709 296.776L200.472 401.977L2109.87 -1507.42Z",
    fill: "#173961"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2004.67 -1612.62L95.2712 296.776L161.022 362.527L2070.42 -1546.87L2004.67 -1612.62Z",
    fill: "#13325A"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_63_7015",
    x1: 401.985,
    y1: -110.663,
    x2: 394.944,
    y2: 61.5374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_63_7015",
    x1: 401.985,
    y1: -110.663,
    x2: 394.944,
    y2: 61.5374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_63_7015",
    x1: 5053.71,
    y1: -1047.01,
    x2: 2167.37,
    y2: -1067.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.139976
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalBackground);
export default __webpack_public_path__ + "static/media/modal-background.974434ea76960d3a37a14703cf56d8e3.svg";
export { ForwardRef as ReactComponent };